import {Component, OnInit} from '@angular/core';
import {map, Observable} from "rxjs";
import {ColDef, RowClickedEvent} from "ag-grid-community";
import {AuditingService} from "../../../services/auditing.service";
import {AuditEventTables} from "../../../table-definitions/audit-event-tables";
import {IAdminAuditEvent} from "../../../interfaces/audit/IAdminAuditEvent";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {AuditTablesBase} from "../audit-tables-base";
import {DateService} from "../../../services/date.service";
import {AuditingDataDisplayComponent} from "../../dialogs/auditing-data-display/auditing-data-display.component";
import {EventSourceType} from "../../../enum/EventSourceType";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MatDialog} from "@angular/material/dialog";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MatFormField, MatFormFieldModule, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatButton} from "@angular/material/button";
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe, NgClass} from "@angular/common";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-admin-audit-table',
  standalone: true,
  templateUrl: './admin-audit-table.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatSelect,
    MatHint,
    MatOption,
    MatLabel,
    MatDatepickerModule,
    MatFormFieldModule,
    MatButton,
    AgGridAngular,
    AsyncPipe,
    MatIcon,
    NgClass
  ],
  styleUrls: ['./admin-audit-table.component.css']
})
export class AdminAuditTableComponent extends AuditTablesBase implements OnInit {

  public adminAudits$: Observable<IAdminAuditEvent[]> = this.auditingService.adminAudits$.pipe(map((responseP) => {
    this.pagedAuditResponse = responseP;
    return responseP.Data;
  }));
  public adminAuditColDefs: ColDef[] = this.auditEventTables.adminAuditEventColDefs;
  public adminIdFormControl: FormControl = new FormControl('');
  public adminAuditFilterFormGroup = new FormGroup(
    {
      adminId: this.adminIdFormControl,
      eventTypeValue: this.eventTypeFormControl,
      fromDate: this.fromDateFormControl,
      toDate: this.toDateFormControl,
      genericContentSearch: this.genericContentSearchFormControl,
      isSuccess: this.isSuccessControl
    }
  );

  constructor(auditingService: AuditingService,
              dateService: DateService,
              matDialog: MatDialog,
              errorHandlingService: ErrorHandlingService,
              auditEventTables: AuditEventTables) {
    super(auditingService, dateService, matDialog, errorHandlingService, auditEventTables);
  }

  ngOnInit() {
    this.auditingService.retrieveAdminAudits(this.defaultFilter).subscribe({
        next: () => {
          this.uiState = UIStateEnum.ShowData
        },
        error: (err) => {
          this.errorHandlingService.displayPageLevelErrorMessage(err);
        }
      }
    )
  }

  onRowSelected(adminAuditP: RowClickedEvent<IAdminAuditEvent>) {
    this.matDialog.open(AuditingDataDisplayComponent, {
      data: {
        audit: adminAuditP.data,
        eventSource: EventSourceType.AdminApp
      }
    })
  }

  override onResetClick() {
    super.onResetClick();
    this.adminIdFormControl.setValue('');
    this.getPaginatedResponse(1);
  }

  getPaginatedResponse(pageNumberP: number): void {
    this.auditingService.retrieveAdminAudits({
      fromDate: new Date(this.fromDateFormControl.value),
      toDate: new Date(this.toDateFormControl.value),
      pageNumber: pageNumberP,
      pageSize: 50,
      eventTypeValue: this.eventTypeFormControl.value,
      adminId: this.adminIdFormControl.value,
      genericContentSearch: this.genericContentSearchFormControl.value,
      isSuccess: this.isSuccessControl.value
    }).subscribe({
      next: () => {
        this.updatePaginator();
      },
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
